<template>
  <v-card
    height="100%"
    class="mx-auto pa-0 rounded-0 height-auto text-left"
    style="min-height: calc(100vh - 48px)"
  >
    <v-navigation-drawer permanent v-model="drawer" :mini-variant.sync="mini">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6" v-if="!user">
            {{ "您好，訪客" }}
          </v-list-item-title>
          <v-list-item-title class="text-h6" v-else>
            {{ !isAdmin ? "您好，使用者" : "您好，管理者" }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ !user ? "統一企業集團特約商店 - 訪客" : user.phoneNumber }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav v-if="!isLoading">
        <v-list-item-group v-model="selectedItem" color="primary">
          <router-link class="nav-link text-decoration-none" href="#" to="/"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>首頁</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="(user && isAdmin) || !user"
            class="nav-link text-decoration-none"
            href="#"
            to="/login"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>{{ !user ? "mdi-login" : "mdi-email" }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  !user ? "登入" : "信箱綁定"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/store-template"
          >
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-storefront-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>商店模板</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/store"
          >
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-storefront</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>商店</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/explore"
          >
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-storefront-edit</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>熱門店家</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/acttype"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-format-list-bulleted-square</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>分類</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/city"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-city</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>城市</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <!-- <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/user"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>使用者</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          > -->
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/message"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-send</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>推播</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/ticket"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-ticket</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>票券</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/light-box"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-lightbulb-on</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>燈箱</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/banner"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-image-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>橫幅</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/picture-box"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>票券資料管理</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/register"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-chart-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>註冊率</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/ticket-log"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-ticket-confirmation</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>取券統計</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <router-link
            v-if="isAdmin"
            class="nav-link text-decoration-none"
            href="#"
            to="/manager"
            ><v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-account-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>管理者</v-list-item-title>
              </v-list-item-content>
            </v-list-item></router-link
          >
          <v-list-item @click="logOut">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>登出</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import { db } from "@/firebase";
import { collection, getDocs } from "firebase/firestore/lite";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

export default {
  data() {
    return {
      desserts: [],
      drawer: true,
      selectedItem: 0,
      items: [
        { title: "Dashboard", icon: "mdi-view-dashboard" },
        { title: "Products", icon: "mdi-image" },
      ],
      right: null,
      mini: false,
      user: "",
      isAdmin: false,
      isLoading: false,
    };
  },
  created() {
    this.check();
    this.$bus.$on("sideBarSelectedItem:push", (num) => {
      this.selectedItem = num;
    });
    this.$bus.$on("check:push", () => {
      this.check();
      this.getManagers();
    });
  },
  methods: {
    check() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/firebase.User
          console.log("Check - 已登入", user);
          this.user = user;
          this.getManagers();
        } else {
          // User is signed out
          // ...
          console.log("Check - 未登入");
          this.user = "";
        }
      });
    },
    async getManagers() {
      this.isLoading = true;
      await getDocs(collection(db, "pictureBox"))
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(doc.id, " => ", doc.data());
            this.desserts.push(doc.data());
          });
          this.isAdmin = true;
          this.isLoading = false;
          console.log("管理者權限");
        })
        .catch(() => {
          this.isAdmin = false;
          this.isLoading = false;
          console.log("非管理者權限");
        });
    },
    logOut() {
      this.isLoading = true;
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          // Sign-out successful.
          console.log("登出成功");
          this.$snackbar.add(`登出成功`, { color: "success" });
          this.user = "";
          this.$router.push("/");
          this.isAdmin = false;
          this.isLoading = false;
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
        });
    },
  },
};
</script>
<style>
.v-application a {
  color: #546e7a !important;
}
</style>
